// Import Vue
import Vue from 'vue';

//Import Vue Quill Editor
import VueQuillEditor from 'vue-quill-editor';
import 'quill/dist/quill.snow.css';

// Start plugin Vue Quill Editor
Vue.use(VueQuillEditor);